import { Button, Drawer, List, ListItem } from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import { ContentJson } from "../../model/ContentJson";
import { useState } from "react";
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import { ClassNames } from "@emotion/react";
import { yellow } from "@mui/material/colors";

export const LayoutMobile: React.FC<{ contentJson: ContentJson }> = ({ contentJson }) => {

    const [flOpen, setOpen] = useState<boolean>(false);

    function getListItems(): React.ReactNode {
        return (            
            Object.entries(contentJson).map(([key, value]) => (                
                <ListItem onClick={toggleOpen} component={Link} to={`/${key}`} key={key}>{value}</ListItem>
            ))      
        )

    }

    function toggleOpen() {
        setOpen(!flOpen);
    }

    return <div className="layout-main">
        <nav className="layout-menu">
            <div title="Содержание">
                <MenuBookOutlinedIcon onClick={toggleOpen} className="icon-class" /> 
            </div>       
            <Drawer open={flOpen} onClose={toggleOpen}>
                <List className="navigator-list">
                    {getListItems()}
                </List>
            </Drawer>
        </nav>
        <nav className="layout-content">
        <Outlet></Outlet>
        </nav>
    </div>
}